import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { SeConnect25BrandingAdminComponent } from "../se.connect25.branding.admin.component";
import { SeConnect25HeroAdminComponent } from "../se.connect25.hero.admin.component";

@TypeManagerDecorator("s25-ng-se-config-appearance-page")
@Component({
    selector: "s25-ng-se-config-appearance-page",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SeConnect25BrandingAdminComponent, SeConnect25HeroAdminComponent],
    template: `
        <div class="c-padding--double se-config-page">
            <s25-ng-se-connect25-branding-admin />
            <div class="se-config-page__section">
                <s25-ng-se-connect25-hero-admin />
            </div>
        </div>
    `,
    styles: `
        :host {
            display: block;
        }

        .se-config-page__section {
            margin-top: 2rem;
            padding-top: 2rem;
            border-top: 1px solid var(--color--border, #e5e5e5);
        }
    `,
})
export class SeConfigAppearancePageComponent {}
